module.exports = __webpack_public_path__ + "static/img/banner.c26a9e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tazg/banner.jpg
// module id = yLdT
// module chunks = 23